export default {
  title: 'Deliverect',
  form: {
    channel_link_id: {
      label: 'Channel Link ID: ',
    },
    store_id: {
      label: 'Externe locatie-id: ',
    },
    store_provisioning_url: {
      label: 'Store provisioning URL: ',
    },
  },
  buttons: {
    save: 'Opslaan',
  },
  toasts: {
    error: 'Wijzigingen opslaan mislukt',
    success: 'Wijzigingen zijn opgeslagen',
  },
  instructions: {
    title: 'Installatie-instructies:',
    step_1:
      'Open de <Link>"Locations"</Link>-pagina in Deliverect, vouw de juiste locatie uit en klik op de knop "+ Channel link".',
    step_2:
      'Vul de benodigde gegevens in. Selecteer bij de stap "Select your online delivery platform" de optie "Food Amigos".',
    step_3: 'Voltooi alle stappen. Klik vervolgens op de pagina "Locations" op "Edit" bij het kanaal "Food Amigos".',
    step_4: 'Klik in de zijbalk op het tabblad "Channel connection" en vul deze gegevens in:',
    step_5: 'Sla de wijzigingen op door rechtsboven op de knop "Save" te klikken.',
    step_6:
      'Klik na het opslaan op het pictogram "More" rechtsboven, vervolgens op "Register" en daarna op "Activate".',
    step_7: 'Ga terug naar het tabblad "General", zet de "Integration status" op "Active" en sla de wijzigingen op.',
    outro: 'Daarna kunt u het menu vanuit Deliverect pushen en een testbestelling aanmaken.',
  },
  connected: {
    title: 'Deliverect is verbonden',
    description: 'Deze integratie is ingesteld.',
  },
};
